import { createRouter, createWebHistory } from "vue-router";
import Login from "@/fontend/Login.vue";
import Main from "@/fontend/Main.vue";
import Ticket_listing from "@/fontend/Ticket_listing.vue";
import Create_ticket from "@/fontend/Ticket_create.vue";
import Ticket_submit from "@/fontend/Ticket_submit.vue";
import Ticket_detail from "@/fontend/Ticket_detail.vue";
import Add_response from "@/fontend/Add_response.vue";


import store from '../vuex/store.js'; 
import PageNotFound from "../pages/PageNotFound.vue"
const routes = [
    {
        name: "Login",
        component: Login,
        path: "/",
        prefix: "auth",
        meta: { requiresAuth: false }
    },
    {
        name: "Main",
        component: Main,
        path: "/main",
        prefix: "auth",
        meta: { requiresAuth: false }
    },
    {
        name: "Ticket_listing",
        component: Ticket_listing,
        path: "/ticket-listing",
        meta: { requiresAuth: false }
    },
    {
        name: "Create_ticket",
        component: Create_ticket,
        path: "/ticket-create",
        meta: { requiresAuth: false }
    },
    {
        name: "Ticket_submit",
        component: Ticket_submit,
        path: "/ticket-submit",
        meta: { requiresAuth: false }
    },
    {
        name: "Ticket_detail",
        component: Ticket_detail,
        path: "/ticket-detail/:ticketId?",
    },
    {
        name: "Add_response",
        component: Add_response,
        path: "/add-response/:ticketId?",
    },

    {
        path: "/:catchAll(.*)",
        name: "PageNotFound",
        component: PageNotFound
    },
]

let router = createRouter({
    history: createWebHistory(),
    mode: 'history',
    routes,
});


router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth == true) {
        next();
    } else {
        if(store.state.isAdmin == 2){
            next('/admin')       
        }else{
            next();
        }
    }
})

export default router;
